// extracted by mini-css-extract-plugin
export default {"mic-icon":"ToggleDictation_mic-icon__R2S6Q","active":"ToggleDictation_active__XY8Zq","pulse":"ToggleDictation_pulse__g41RK"};